import { Workflow } from 'modules/workflows';
import { LinkedWorkflow } from './LinkedWorkflow';
import { OTHER_JOURNEY_SOURCE_TEST_ID } from '../StartNodeEditor.constants';
import { useStartNodeContext } from '../StartNodeEditor.context';

export const OtherJourneyEntrySource = () => {
  const { workflowData, setHasLinkedJourneys } = useStartNodeContext();
  const handleLoadStatusUpdate = ({ workflows }: { workflows: Workflow[] }) => {
    if (workflows.length) setHasLinkedJourneys(true);
  };
  return (
    <div data-test={OTHER_JOURNEY_SOURCE_TEST_ID}>
      <LinkedWorkflow
        currentWorkflow={workflowData as Workflow}
        onLoadStatusUpdate={handleLoadStatusUpdate}
      />
    </div>
  );
};
